import { IHttpApi } from '@cian/http-api/shared';
import {
  fetchCianApiSiteV1SearchRegionsCities,
  ICianApiSiteV1SearchRegionsCitiesRequest,
  TCianApiSiteV1SearchRegionsCitiesResponse,
} from '../repositories/monolith-python/cian-api/site/v1/search-regions-cities';

import { isResponseContainsKey } from './helpers';
import { IErrorResponseSchema51 } from '../repositories/monolith-python/entities/schemas/ErrorResponseSchema51';
import { ISearchRegionsCitiesResponseSchema50 } from '../repositories/monolith-python/entities/schemas/SearchRegionsCitiesResponseSchema50';

export async function searchRegionsCities(
  httpApi: IHttpApi,
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest,
  subdomain?: string,
) {
  const { response } = await fetchCianApiSiteV1SearchRegionsCities<
    TCianApiSiteV1SearchRegionsCitiesResponse,
    TCianApiSiteV1SearchRegionsCitiesResponse
  >({
    httpApi,
    parameters,
    config: {
      subdomain: subdomain || 'www',
    },
  });

  if (isResponseContainsKey<IErrorResponseSchema51, ISearchRegionsCitiesResponseSchema50>(response, 'errors')) {
    throw response;
  }

  return response;
}
